export default __webpack_public_path__ + "static/media/arrow-grey-down.7b33e1bb.svg";